import { motion } from "framer-motion";

import { Button } from "../../../../atoms";

export const CTAWidget = ({
  title,
  subtitle,
  buttonText,
  icon,
}: {
  title: string;
  subtitle: string;
  buttonText: string;
  icon: React.ReactNode;
}) => {
  return (
    <motion.div
      layout
      initial={{ opacity: 0, y: 8, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -8, scale: 0.98 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
      className="shadow-xs bg-gray-0 border-secondary-500 relative flex min-w-full justify-between gap-3 overflow-hidden rounded-2xl border p-3"
    >
      <div className="z-20 flex w-full flex-col flex-wrap justify-between gap-3">
        <div className="flex flex-col gap-0.5">
          <div className="text-base font-bold text-gray-950">{title}</div>
          <div className="text-xs font-medium text-gray-500">{subtitle}</div>
        </div>
        <Button
          className="size-fit px-6 text-sm font-semibold"
          intent="secondary"
        >
          {buttonText}
        </Button>
      </div>
      {icon}
    </motion.div>
  );
};
